/* global dataLayer */

"use strict";

import Toolbox from "./toolbox";



const priceHistoryHandlerWorkset = {
	priceHistoryContainer: false
};

let _settings = {
	container: ".price-history-container", // Container (parent) selector.
	mode: "standalone"
};

function init() {
	//.page-home .site-content
	const priceHistoryContainers = document.querySelectorAll(_settings.container + ", .page-brands .product-filter-results, #search-results.product-list-grid, #related-search-results.product-list-grid");
	for (const priceHistoryContainer of priceHistoryContainers) {
		priceHistoryContainer.addEventListener("click", function (e) {
			if (priceHistoryContainer.classList.contains("product-filter-results") || ["search-results", "related-search-results"].includes(priceHistoryContainer.id)) {
				showPriceHistory(e.target, { mode: "listing" });
			} else {
				showPriceHistory(e.target, { mode: "standalone" });
			}
		});
	}
}

function openPanel(error) {
	setTimeout(() => {
		if (priceHistoryHandlerWorkset.priceHistoryContainer) {
			if (!error) {
				priceHistoryHandlerWorkset.priceHistoryContainer.classList.add("price-history-open");
			}
			priceHistoryHandlerWorkset.priceHistoryContainer.classList.remove("price-history-loading");
		}
	}, 100);
}

function fetchProductPriceHistory(sapCode, sapColour) {

	const request = new XMLHttpRequest();

	request.open("GET", "/stage-ajax/getProductPriceHistory/?sapCode=" + sapCode + "&sapColour=" + sapColour, true);

	request.onload = function () {
		if (request.status >= 200 && request.status < 400) {
			try {
				const result = JSON.parse(request.responseText);
				if (priceHistoryHandlerWorkset.priceHistoryContainer && result.status === "ok") {
					const div = document.createElement("div");
					div.innerHTML = result.rendered;
					const rendered = div.querySelector(".price-history-panel");

					if (dataLayer && result.meta) {
						const eventObject = {
							event: "GAEvent",
							eventCategory: "Price History",
							eventAction: result.meta.productCategories, //sapCode+"_"+sapColour,
							eventLabel: result.meta.product //rendered.dataset.pricePercentageDifference
						};
						dataLayer.push(eventObject);
					}

					priceHistoryHandlerWorkset.priceHistoryContainer.appendChild(rendered);
					openPanel();
				} else {
					openPanel(true);
				}

			} catch (error) {
				openPanel(true);
			}

		} else {
			openPanel(true);

		}
	};

	request.onerror = function () {
		openPanel(true);
	};

	priceHistoryHandlerWorkset.priceHistoryContainer.classList.add("price-history-loading");

	request.send();


}

let hasOutsideClickDetectorListener = false;
function coutsideClickDetector(e) {
	const element = e.target;
	if (!Toolbox.closest(element, ".price-history-panel") && document.body.querySelector(".price-history-panel")) {
		closePanels();
	}
}

function closePanels() {
	const openPanels = document.querySelectorAll(_settings.container + ".price-history-open");
	if (hasOutsideClickDetectorListener) {
		document.body.removeEventListener("click", coutsideClickDetector);
		hasOutsideClickDetectorListener = false;
	}

	for (let i = 0; i < openPanels.length; i++) {
		openPanels[i].classList.add("price-history-closing");
		openPanels[i].classList.remove("price-history-open");
		setTimeout(() => {
			openPanels[i].classList.remove("price-history-closing");
			const priceHistoryPanel = openPanels[i].querySelector(".price-history-panel");
			priceHistoryPanel.parentNode.removeChild(priceHistoryPanel);
		}, 301);
	}

}

function showPriceHistory(clickedElement, settings) {

	if (settings) {
		for (const key of Object.keys(settings)) {
			_settings[key] = settings[key];
		}
	}

	switch (_settings.mode) {
		case "standalone":
			_settings.container = ".price-history-container";
			break;
		case "listing":
			_settings.container = ".product-list-item";
			break;

		default:
			_settings.mode = "standalone";
			_settings.container = ".price-history-container";
			break;
	}

	const priceHistoryContainer = Toolbox.closest(clickedElement, _settings.container);
	priceHistoryHandlerWorkset.priceHistoryContainer = priceHistoryContainer;

	let mode = clickedElement.classList.contains("open-button") || clickedElement.classList.contains("price-history-text") ? "open" : clickedElement.classList.contains("close-button") ? "close" : "doNothing";

	if ((clickedElement.classList.contains("open-button") || clickedElement.classList.contains("price-history-text")) && priceHistoryContainer.classList.contains("price-history-open")) {
		mode = "close";
	}

	if (priceHistoryContainer && mode !== "doNothing" && !priceHistoryContainer.classList.contains("price-history-loading")) {
		if (mode === "open") {
			closePanels();

			if (_settings.mode === "standalone" && !hasOutsideClickDetectorListener) {
				setTimeout(() => {
					document.body.addEventListener("click", coutsideClickDetector);
				}, 100);

				hasOutsideClickDetectorListener = true;
			}

			fetchProductPriceHistory(priceHistoryContainer.dataset.id, priceHistoryContainer.dataset.color);

		} else {
			closePanels();
		}
	}

}

export default {
	showPriceHistory: showPriceHistory,
	init: init
};
